import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveAccount = async (uuid: string) => {
  const response = await CustomAxios.post(`accounts/${uuid}/archive`);
  return response.data;
};

interface UseArchiveAccountProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveAccount({ uuid, onSuccessCallback }: UseArchiveAccountProps) {
  return useMutation({
    mutationFn: () => archiveAccount(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAccounts, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the account. Please try again and contact support if the problem persists.');
      }
    },
  });
}
